import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, of } from 'rxjs';
import { ErrorService } from 'src/app/error/err.service';
import { environment } from "src/environments/environment";
import { delay } from 'rxjs/operators';
import { LongPollingStatelessProgress } from 'src/app/shared/stateapimanagement/longpollingstateless-progress';
import { SharedService } from 'src/app/services/shared.service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { RESTPROMISE } from 'src/app/shared/stateapimanagement/promisewithoutstate';

@Injectable({
  providedIn: 'root'
})
export class WidgetbuilderService {

  constructor(
    private http:HttpClient,
    private sharedService: SharedService,
    private errorservice: ErrorService,
    private toastService: ToastService
  ) { 
    this.sharedService.$userLoggedoff.pipe().subscribe((loggedoff) => {
      this.customerChangeLogggedOff.next(loggedoff);
    })
  }

  customerChangeLogggedOff: Subject<boolean> = new Subject();

  widgetbuilderDestroyed:Subject<number> = new Subject();
// Need to remove as per shared service
    headers = new HttpHeaders({'content-type': 'application/json','charset':'utf-8'}); 

  getchartdata = new LongPollingStatelessProgress(
    this.getChartData,
    this.http, 
    this.sharedService.userLoggedoff_,
    this.errorservice,
    'studio/widget-builder/chartdata/get',
    'Studio',
    this.toastService
  )

  getChartData(reqobj:any){
    // return this.http.post(environment.apiUrl+'/studio/widget-builder/chartdata/get',reqobj,{ headers: this.headers })
    const dummy_result = {
      "widget_data": [
        { "srccountry": "United States", "count": 79279374, "service": "DNS" },
        { "srccountry": "Bulgaria", "count": 42341746, "service": "DNS" },
        { "srccountry": "Canada", "count": 11645166, "service": "DNS" },
        { "srccountry": "Japan", "count": 6372602, "service": "DNS" },
        { "srccountry": "China", "count": 4965806, "service": "DNS" },
        { "srccountry": "United Kingdom", "count": 4769631, "service": "DNS" },
        { "srccountry": "Singapore", "count": 4204418, "service": "DNS" },
        { "srccountry": "Estonia", "count": 3995252, "service": "DNS" },
        { "srccountry": "Russian Federation", "count": 3571994, "service": "DNS" },
        { "srccountry": "Iran, Islamic Republic of", "count": 3027273, "service": "DNS" },
        { "srccountry": "Germany", "count": 2127356, "service": "DNS" },
        { "srccountry": "India", "count": 1419962, "service": "DNS" },
        { "srccountry": "Hong Kong", "count": 1242623, "service": "DNS" },
        { "srccountry": "Netherlands", "count": 937715, "service": "DNS" },
        { "srccountry": "South Africa", "count": 726215, "service": "DNS" },
        { "srccountry": "Brazil", "count": 654514, "service": "DNS" },
        { "srccountry": "Ukraine", "count": 625662, "service": "DNS" },
        { "srccountry": "Korea, Republic of", "count": 609682, "service": "DNS" },
        { "srccountry": "France", "count": 585298, "service": "DNS" },
        { "srccountry": "Denmark", "count": 517499, "service": "DNS" },
        { "srccountry": "Poland", "count": 462869, "service": "DNS" },
        { "srccountry": "Romania", "count": 449213, "service": "DNS" },
        { "srccountry": "Portugal", "count": 364238, "service": "DNS" },
        { "srccountry": "Taiwan", "count": 331179, "service": "DNS" },
        { "srccountry": "Ireland", "count": 291861, "service": "DNS" }
      ],
      "chart_option": {
        "color": [
          "#0081b8",
          "#737373",
          "#454545",
          "#9e57bc",
          "#e0eff6",
          "#a6d4e7"
        ],
        "tooltip": {
          "trigger": "item"
        },
        "xAxis": {
          "type": "category",
          "axisLine": {
            "lineStyle": {
              "opacity": 0.2
            }
          },
          "data": [
            "United States",
            "Bulgaria",
            "Canada",
            "Japan",
            "China",
            "United Kingdom",
            "Singapore",
            "Estonia",
            "Russian Federation",
            "Iran, Islamic Republic of",
            "Germany",
            "India",
            "Hong Kong",
            "Netherlands",
            "South Africa",
            "Brazil",
            "Ukraine",
            "Korea, Republic of",
            "France",
            "Denmark",
            "Poland",
            "Romania",
            "Portugal",
            "Taiwan",
            "Ireland"
          ],
          "name": "",
          "nameGap": 60,
          "nameLocation": "end",
          "nameTextStyle": {
            "align": "right",
            "lineHeight": 60,
            "verticalAlign": "top",
            "fontSize": 12,
            "fontWeight": "bold"
          }
        },
        "yAxis": {
          "type": "value",
          "name": "",
          "nameLocation": "end",
          "nameRotate": 0,
          "nameGap": 20,
          "nameTextStyle": {
            "align": "left",
            "lineHeight": 0,
            "padding": [
              -10,
              -60
            ],
            "verticalAlign": "top",
            "fontSize": 12,
            "fontWeight": "bold"
          }
        },
        "grid": {
          "left": "4%",
          "right": "11%",
          "bottom": "7%",
          "top": "21%",
          "containLabel": true
        },
        "series": [
          {
            "data": [
              79279374,
              42341746,
              11645166,
              6372602,
              4965806,
              4769631,
              4204418,
              3995252,
              3571994,
              3027273,
              2127356,
              1419962,
              1242623,
              937715,
              726215,
              654514,
              625662,
              609682,
              585298,
              517499,
              462869,
              449213,
              364238,
              331179,
              291861
            ],
            "type": "bar"
          }
        ]
      }
    }

    return of(dummy_result)
  }

  getDataSetOptions = new RESTPROMISE(
    this.dataSetOptionsGet,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    '/studio/widget-builder/data-set-options/get',
    'Designer',
    this.toastService
)

getWidgetData = new RESTPROMISE(
  this.widgetDataGet,
  this.http,
  this.customerChangeLogggedOff.asObservable(),
  this.errorservice,
  '/studio/widget-builder/widget-types/get',
  'Designer',
  this.toastService
)

getChartOptionsData = new RESTPROMISE(
  this.chartOptionsDataGet,
  this.http,
  this.customerChangeLogggedOff.asObservable(),
  this.errorservice,
  '/studio/widget-builder/chart-data/get',
  'Designer',
  this.toastService
)

getDataSet = new RESTPROMISE(
  this.dataSetGet,
  this.http,
  this.customerChangeLogggedOff.asObservable(),
  this.errorservice,
  '/studio/widget-builder/data-set/get',
  'Designer',
  this.toastService
)

  getEditWidget(req){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/widget/edit/get',req,{ headers: this.headers })
  }

  postWidget(req){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/widget/post',req,{ headers: this.headers })
  }

  chartOptionsDataGet(req){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/chart-data/get',req,{ headers: this.headers })
  }
  
  widgetDataGet(req){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/widget-types/get',req,{ headers: this.headers })
  }

  dataSetGet(req){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/data-set/get',req,{ headers: this.headers })
  }
  
  dataSetOptionsGet(req){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/data-set-options/get',req,{ headers: this.headers })
  }

  post_widget(reqobj:any){
    return this.http.post(environment.apiUrl+'/studio/widget-builder/widget/post',reqobj,{ headers: this.headers })
  }

  getChartList(){
    return this.http.post(environment.apiUrl + '/studio/widget-builder/chart/list/get', JSON.stringify({chart_type:"all"}), { headers: this.headers })
  }

  checkIfWidgetnameExists(widgetname: string) {
    return this.http.post(environment.apiUrl + '/studio/widget-builder/name/check', JSON.stringify({ widgetname }), { headers: this.headers }).pipe(delay(1000))
  }

  getAlertFields(platform:any){
    return this.http.post(environment.apiUrl + '/common/alertFields/get', JSON.stringify(platform), { headers: this.headers})
  }
  
}
